// extracted by mini-css-extract-plugin
export default {"modal":"RentalFeeModal_modal__QJ5dB"};